// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"wR-z","categoryName":"xR-z","categoryNameSearchHeader":"yR-z","categoryContent":"zR-z","bottomAligned":"AR-z","image":"BR-z","imageNoBackground":"CR-z"};